var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVerifiedUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m10.95 12.684-1.4-1.418a.95.95 0 0 0-.7-.304q-.4 0-.7.304t-.3.721q0 .419.3.722l2.1 2.152q.3.304.7.304t.7-.304l4.25-4.304q.3-.304.3-.722t-.3-.721a.97.97 0 0 0-.713-.304.97.97 0 0 0-.712.304zM12 22a2 2 0 0 1-.625-.101Q8 20.759 6 17.683q-2-3.075-2-6.62V6.278q0-.632.362-1.139.363-.506.938-.734l6-2.278Q11.65 2 12 2t.7.127l6 2.278q.575.228.938.734.362.507.362 1.14v4.784q0 3.545-2 6.62T12.625 21.9A2 2 0 0 1 12 22m0-2.025q2.6-.835 4.3-3.342 1.7-2.506 1.7-5.57V6.278L12 4 6 6.278v4.785q0 3.063 1.7 5.57 1.7 2.506 4.3 3.342"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerifiedUser);
export default __webpack_public_path__ + "static/media/verified_user.4f3581dc30a8255216e45508771f77f9.svg";
export { ForwardRef as ReactComponent };